import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TopNav from "@/components/Navigation/TopNav/TopNav.component.vue";
import NavMain from "@/components/Navigation/Nav/NavMain.component.vue";
import FooterBottom from "@/components/Navigation/Footer/FooterBottom.component.vue";
import ButtonWhatApp from "./components/ButtonWhatsApp/ButtonWhatApp.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopNav),
    _createVNode(NavMain),
    _createVNode(_component_router_view),
    _createVNode(FooterBottom),
    _createVNode(ButtonWhatApp)
  ], 64))
}
}

})